var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMoonDark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 8.40541C12.9212 9.25832 12.6011 10.0711 12.0772 10.7488C11.5532 11.4264 10.8472 11.9408 10.0416 12.2318C9.23597 12.5228 8.36416 12.5783 7.52814 12.3919C6.69213 12.2055 5.92649 11.7848 5.32082 11.1792C4.71515 10.5735 4.2945 9.80787 4.10809 8.97186C3.92168 8.13584 3.97722 7.26403 4.26821 6.45842C4.5592 5.65282 5.0736 4.94675 5.75123 4.42283C6.42886 3.89892 7.24168 3.57882 8.09459 3.5C7.59524 4.17557 7.35495 5.00792 7.41742 5.84568C7.4799 6.68344 7.84099 7.47095 8.43502 8.06498C9.02905 8.65901 9.81656 9.0201 10.6543 9.08258C11.4921 9.14505 12.3244 8.90476 13 8.40541Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoonDark);
export default __webpack_public_path__ + "static/media/moon-dark.fc01a461cd56735307bae1f04ec75ce9.svg";
export { ForwardRef as ReactComponent };